import { Message } from 'element-ui';
import * as types from './mutation-types';
import Request from '@/core/QuRequest';
import * as $cache from '@/common/cache';
// import ewxLoginSDK from '@qtt/ewx-login-sdk';
import Cookies from 'js-cookie';
import { localStorage } from '@/common/storage';

const req = new Request();

const actions = {
  // 鉴权信息(老的同步信息方式需要这个信息，新方法用下面的token)
  getAuthUser(ctx, payload) {
    try {
      const info = JSON.parse($cache.localGet($cache.AUTH).content);
      ctx.commit(types.FETCH_USER, info);
    } catch (err) {}
  },

  // 拿鉴权token(新的同步信息方式), 通过wx的token来换取用户的token
  getAuthToken(ctx, payload) {
    try {
      const info =
        localStorage.getItem('token') || $cache.localGet($cache.AUTH).token;
      ctx.commit(types.FETCH_TOKEN, info);
    } catch (err) {}
  },

  // 同步用户信息
  async syncUser(ctx, payload) {
    try {
      const userCache = $cache.localGet($cache.AUTH);
      const advCookie = Cookies.get('advanced-frontend');

      // 当 crmCache不存在 或 advCookie失效，则重新同步登录
      if (!(userCache && advCookie)) {
        const params = { token: ctx.state.token || '' };
        const user = ((await req.send(req.Apis.sales.user.syncAuth, params)) || {}).data || {};

        // 更新 status
        ctx.commit(types.FETCH_SYNC_USER, user);

        // 设置crm系统cache
        $cache.localSet($cache.AUTH, user);

        // 设置adv系统cookie
        Cookies.set('advanced-frontend', user.session_id, {
          expires: 1 / 12, // 2h 过期
          domain: '.aiclk.com',
          path: '/'
        });
      } else {
        const user = userCache;
        ctx.commit(types.FETCH_SYNC_USER, user);
      }

      return true;
    } catch (err) {
      Message.error(err.message || '请求错误');
      return false;
    }
  },

  getSysUser(ctx) {
    const user = $cache.localGet($cache.AUTH);
    ctx.commit(types.FETCH_SYNC_USER, user);
  },

  // 系统权限相关
};

export default actions;
